import { useMutation } from '@tanstack/react-query';
import { JsonValue } from 'type-fest';

import {
  useRequest,
  type MutationFunction,
  type ValidationErrorItem,
} from '@frontend/api';

import type { Rule } from './types';

export type RulesJsonUploadRequestBody = {
  rulesData: Partial<Rule>[];
};

export type RulesJsonUploadResult = {
  created: number;
  updated: number;
  errors: { key: string; errors: ValidationErrorItem[] }[];
};

export const useRulesJsonUpload: MutationFunction<
  RulesJsonUploadResult,
  RulesJsonUploadRequestBody
> = ({ requestOptions, queryOptions } = {}) => {
  const urlPath = '/rules/json_upload/';
  const request = useRequest(requestOptions);

  return useMutation(
    (body) => {
      return request<RulesJsonUploadResult & JsonValue>(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: ['rulesJsonUpload'],
    },
  );
};
